import "./Moderator.scss";

import upload from "../../assets/images/icons/upload.svg";
import sort from "../../assets/images/icons/sort.svg";
import deletePurple from "../../assets/images/icons/delete.svg";
import search from "../../assets/images/icons/Search.svg";

import { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import axios from "axios";
import ReactPaginate from "react-paginate";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import TopNav from "../../components/TopNav/TopNav";
import SideBar from "../../components/SideBar/SideBar";

function Moderators() {
    const tabs = ["name", "time", "status"];
    const headings = ["Venue", "Name", "Email", "Phone Number", "Status", ""];

    const [mods, setMods] = useState([]);
    const [displayMods, setDisplayMods] = useState([]);

    //GETTING INITIAL MODS ================================================================

    useEffect(() => {
        const getMods = async () => {
            try {
                const response = await axios.get(`https://zona-app-server-584d567d8841.herokuapp.com/moderators`);
                setMods(response.data);
            } catch (error) {
                console.log(`Couldn't get moderators. This is the error: ${error}`);
            }
        };
        getMods();
    }, []);

    //SEARCH BAR ===========================================================================

    const [searchQuery, setSearchQuery] = useState("");
    const [activeSearch, setActiveSearch] = useState(false);
    const [filderedMods, setFilteredMods] = useState([]);

    function handleChange(event) {
        setActiveSearch(true);
        setSearchQuery(event.target.value);

        const filtered = mods.filter(
            (item) =>
                item.venue.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.email.toLowerCase().includes(event.target.value.toLowerCase()) ||
                item.phoneNumber.includes(event.target.value) ||
                item.status.toLowerCase().includes(event.target.value.toLowerCase())
        );
        setFilteredMods(filtered);
    }

    useEffect(() => {
        activeSearch ? setDisplayMods(filderedMods) : setDisplayMods(mods);
    }, [activeSearch, filderedMods, mods]);

    function handleExitSearch() {
        setActiveSearch(false);
        setSearchQuery("");
    }

    //EXPORTING CSV FILE ===================================================================

    function handleExportDataClick() {
        try {
            const csvRows = [];
            // Extracting headers
            const headers = Object.keys(mods[0]);
            csvRows.push(headers.join(","));

            // Extracting data rows
            for (const row of mods) {
                const values = headers.map((header) => {
                    const escapedValue = row[header].toString().replace(/"/g, '\\"');
                    return `"${escapedValue}"`;
                });
                csvRows.push(values.join(","));
            }

            // Combine rows into CSV content
            const csvContent = csvRows.join("\n");

            // Convert CSV content to blob
            const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

            // Trigger download
            saveAs(csvBlob, "moderators_data.csv");
        } catch (error) {
            console.error("Error converting JSON to CSV:", error);
        }
    }

    //STATUS CLASSES ========================================================================

    function classForStatus(stat) {
        switch (stat) {
            case "pending":
                return "moderators__table-info-info-status--pending";
            case "approved":
                return "moderators__table-info-info-status--approved";
            case "denied":
                return "moderators__table-info-info-status--denied";
            default:
                return "moderators__table-info-info-status";
        }
    }

    //HANDLINE SORTS ========================================================================

    const [nameSortClicks, setNameSortClicks] = useState(1);
    const [statusSortClick, setStatusSortClicks] = useState(1);

    function handleSortClick(by) {
        switch (by) {
            case "name":
                setNameSortClicks((prevCount) => prevCount + 1);
                applyNameFilter();
                break;
            //need to add filter for sorting by time
            case "status":
                setStatusSortClicks((prevCount) => prevCount + 1);
                applyStatusFilter();
                break;
            default:
                break;
        }
    }

    function applyNameFilter() {
        let sortedMods;

        switch (nameSortClicks) {
            case 1:
                const sortedByNameAZ = [...displayMods].sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
                sortedMods = sortedByNameAZ;
                break;
            case 2:
                const sortedByNameZA = [...displayMods].sort((a, b) => {
                    return b.name.localeCompare(a.name);
                });
                sortedMods = sortedByNameZA;
                break;
            case 3:
                sortedMods = mods;
                setNameSortClicks(1);
                break;
            default:
                break;
        }

        setDisplayMods(sortedMods);
    }

    function applyStatusFilter() {
        let sortedMods;

        switch (statusSortClick) {
            case 1:
                const sortedByStatusPAD = [...displayMods].sort((a, b) => {
                    const statusOrder = {
                        pending: 1,
                        approved: 2,
                        denied: 3,
                    };
                    return statusOrder[a.status] - statusOrder[b.status];
                });
                sortedMods = sortedByStatusPAD;
                break;
            case 2:
                const sortedByStatusADP = [...displayMods].sort((a, b) => {
                    const statusOrder = {
                        approved: 1,
                        denied: 2,
                        pending: 3,
                    };
                    return statusOrder[a.status] - statusOrder[b.status];
                });
                sortedMods = sortedByStatusADP;
                break;
            case 3:
                const sortedByStatusDPA = [...displayMods].sort((a, b) => {
                    const statusOrder = {
                        denied: 1,
                        pending: 2,
                        approved: 3,
                    };
                    return statusOrder[a.status] - statusOrder[b.status];
                });
                sortedMods = sortedByStatusDPA;
                break;
            case 4:
                sortedMods = mods;
                setStatusSortClicks(1);
                break;
            default:
                break;
        }
        setDisplayMods(sortedMods);
    }

    //HANDLING DELETES =============================================

    const [deleteModal, setDeleteModal] = useState(false);
    const [modToDelete, setModToDelete] = useState("");

    function handleDeleteMod(mod) {
        setDeleteModal(true);
        setModToDelete(mod);
    }

    function handleDelete(id) {
        console.log("this is the id: ", id);
        const deleteMod = async () => {
            try {
                const response = await axios.delete(
                    `https://zona-app-server-584d567d8841.herokuapp.com/moderators/${id}`
                );
                console.log(response);
                alert("Successfully deleted!");
                setDeleteModal(false);
            } catch (error) {
                alert("could not delete!");
                setDeleteModal(false);
            }
        };
        deleteMod();
    }

    //PAGINATION ===================================================

    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage] = useState(10);

    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = displayMods.slice(indexOfFirstPost, indexOfLastPost);

    const paginate = ({ selected }) => {
        setCurrentPage(selected + 1);
    };

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                {deleteModal && (
                    <DeleteModal
                        handleDelete={handleDelete}
                        setDeleteModal={setDeleteModal}
                        modToDelete={modToDelete}
                        tableName={"Moderators"}
                    />
                )}
                <article style={{ width: "100%", display: "flex", alignItems: "center", flexDirection: "column" }}>
                    <section className="moderators">
                        <div className="moderators__top">
                            <h1 className="moderators__top-heading">Moderator</h1>

                            <div className="moderators__top-right">
                                <div className="moderators__top-right-search">
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <label htmlFor="search">
                                            <img
                                                src={search}
                                                className="moderators__top-right-search-icon"
                                                alt="magnifying glass"
                                            ></img>
                                        </label>
                                        <input
                                            id="search"
                                            type="text"
                                            className="moderators__top-right-search-input"
                                            placeholder="Search..."
                                            value={searchQuery}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    {activeSearch && (
                                        <div onClick={handleExitSearch} className="moderators__top-right-search-x">
                                            <p className="moderators__top-right-search-x-text">X</p>
                                        </div>
                                    )}
                                </div>

                                <button onClick={handleExportDataClick} className="moderators__top-right-button">
                                    Export data
                                    <img
                                        className="moderators__top-right-button-icon"
                                        src={upload}
                                        alt="upload icon"
                                    ></img>
                                </button>
                            </div>
                        </div>

                        <div className="moderators__sorts">
                            {tabs.map((tab, index) => (
                                <button
                                    onClick={() => handleSortClick(tab)}
                                    key={index}
                                    className="moderators__sorts-button"
                                >
                                    <p className="moderators__sorts-button-text">Sort by {tab}</p>

                                    <img className="moderators__sorts-button-icon" src={sort} alt="sort icon"></img>
                                </button>
                            ))}
                        </div>

                        <table className="moderators__table">
                            <thead className="moderators__table-top">
                                <tr className="moderators__table-top-headings">
                                    {headings.map((heading, index) => (
                                        <th className="moderators__table-top-headings-heading" key={index} scope="col">
                                            {heading}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody className="moderators__table-info">
                                {currentPosts.map((moderator) => (
                                    <tr key={moderator.id} className="moderators__table-info-info">
                                        <td className="moderators__table-info-info-text">{moderator.venue}</td>
                                        <td className="moderators__table-info-info-text">{moderator.name}</td>
                                        <td className="moderators__table-info-info-text">{moderator.email}</td>
                                        <td className="moderators__table-info-info-text">{moderator.phoneNumber}</td>
                                        <td className="moderators__table-info-info-text moderators__table-info-info-text--status-box">
                                            <p className={classForStatus(moderator.status)}>{moderator.status}</p>
                                        </td>
                                        <td className="moderators__table-info-info-text">
                                            <img
                                                onClick={() => handleDeleteMod(moderator)}
                                                src={deletePurple}
                                                alt="purple garbage bin"
                                            ></img>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </section>
                    <div className="pagination-container">
                        <ReactPaginate
                            onPageChange={paginate}
                            pageCount={Math.ceil(displayMods.length / postsPerPage)}
                            previousLabel={"<"}
                            nextLabel={">"}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            containerClassName={"pagination"}
                            pageLinkClassName={"page-number"}
                            previousLinkClassName={"page-number-prev"}
                            nextLinkClassName={"page-number-next"}
                            activeLinkClassName={"active-number"}
                        />
                    </div>
                </article>
            </div>
        </main>
    );
}

export default Moderators;
